import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Send01 = function Send01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m10.4995 13.5001 10.5-10.5M10.6271 13.828l2.6281 6.758c.2315.5954.3473.893.5141.9799a.5.5 0 0 0 .4615.0003c.1669-.0867.2831-.3842.5153-.9793l6.5903-16.8877c.2097-.5372.3145-.8058.2571-.9775a.5.5 0 0 0-.3158-.3158c-.1716-.0573-.4402.0475-.9774.2571L3.4126 9.2536c-.5951.2322-.8926.3483-.9793.5152a.5.5 0 0 0 .0002.4616c.087.1668.3846.2825.98.5141l6.758 2.6281c.1208.047.1812.0705.2321.1068a.5.5 0 0 1 .1167.1167c.0363.0508.0598.1113.1068.2321"
    })
  }));
};
export default Send01;